import Vue from 'vue';
import Vuex from 'vuex';
import { getModule } from 'vuex-module-decorators';

import EventsStore from './events';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    eventsStore: EventsStore,
  },
  plugins: [],
});

export default store;

export const eventsStore = getModule<EventsStore>(EventsStore, store);
